var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"dropdown"}},[(_vm.isOpen)?_c('div',{class:_vm.dropdownClass},[(_vm.hasArrow)?_c('div',{staticClass:"dropdown__arrow"}):_vm._e(),_c('div',{ref:"dropdownBody",staticClass:"dropdown__body"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }